import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'
import ScrollReveal from '../ScrollReveal'


const Projects = ({openModal,setOpenModal}) => {
  const [toggle, setToggle] = useState('all');
  const filteredProjects = toggle === 'all'
    ? projects
    : projects.filter((item) => item.category === toggle);

  return (
    <Container id="projects">
      <Wrapper>
        <ScrollReveal direction="down" index={0}>
          <Title>Projects</Title>
        </ScrollReveal>
        <ScrollReveal direction="down" index={1}>
          <Desc>
            I have worked on a wide range of projects. From web apps to android apps. Here are some of my projects.
          </Desc>
        </ScrollReveal>
        <ScrollReveal direction="down" index={2}>
          <ToggleButtonGroup >
            {toggle === 'all' ?
              <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
              :
              <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
            }
            <Divider />
            {toggle === 'web app' ?
              <ToggleButton active value="web app" onClick={() => setToggle('web app')}>WEB APP'S</ToggleButton>
              :
              <ToggleButton value="web app" onClick={() => setToggle('web app')}>WEB APP'S</ToggleButton>
            }
            <Divider />
            {toggle === 'android app' ?
              <ToggleButton active value="android app" onClick={() => setToggle('android app')}>ANDROID APP'S</ToggleButton>
              :
              <ToggleButton value="android app" onClick={() => setToggle('android app')}>ANDROID APP'S</ToggleButton>
            }
            <Divider />
          </ToggleButtonGroup>
        </ScrollReveal>
        <CardContainer>
          {filteredProjects.map((project, idx) => (
            <ScrollReveal key={project.id} direction="down" index={idx + 3}>
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            </ScrollReveal>
          ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects